import { useEffect, useState } from 'react'
import { accountResumeAnual } from "../../Api";
import { setTitlePage } from "../../Functions";

const AccountResumeAnual = () => {

  const [state, setState] = useState<any>({
    loading: false,
  });

  const loadData = async () => {
    setState({
      loading: true,
    });
    const _response: any = await accountResumeAnual({});
    if (_response.status) {
      setState({
        anual: _response.data.anual,
        years: _response.data.years,
        loading: false,
      });
    }
  }

  useEffect(() => {
    setTitlePage('Resumen de Cuentas Anual');
    loadData();
  }, [])


  return (
    <>
      <div className="amount-not-with-drawn">
        {state?.anual === undefined ? (
          <div className="loader p-3 text-center">
            <p className="text-center">Cargando...</p>
          </div>
        ) : (
          <div className='row card'>
            <div className="col-12 card-body table-responsive">
              <table className="table table-row-bordered table-payment-datail">
                <thead className='fs-6 text-gray-400'>
                  <tr>
                    <th></th>
                    {state?.years !== undefined &&
                      Object.keys(state?.years).map((item, index) => (
                        <th key={index} style={{color: '#000', fontWeight: 'bold', textAlign: 'right'}}>{state?.years[item]}</th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {state?.anual.map((item: any, index: any) => (
                    <tr key={index}>
                      <td className="text-left pt-7 pb-3" style={{paddingLeft: '20px'}}>
                        <span className="p-3 fw-bold" style={{width: "fit-content"}}>
                        {item.Glosa}
                        </span>
                      </td>
                      <td className="text-right" style={{textAlign: 'right'}}>
                        {item.Glosa !== '% PAGOS' ? '$ ' + new Intl.NumberFormat("de-DE").format(item.Tramo_1) : item.Tramo_1 + ' %'}
                      </td>
                      <td className="text-right" style={{textAlign: 'right'}}>
                        {item.Glosa !== '% PAGOS' ? '$ ' + new Intl.NumberFormat("de-DE").format(item.Tramo_2) : item.Tramo_2 + ' %'}
                      </td>
                      <td className="text-right" style={{textAlign: 'right'}}>
                        {item.Glosa !== '% PAGOS' ? '$ ' + new Intl.NumberFormat("de-DE").format(item.Tramo_3) : item.Tramo_3 + ' %'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default AccountResumeAnual